// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.table-container {
    /* max-height: calc(100vh - 365px); */
    overflow: auto;
}

table {
    overflow: auto;
    border-collapse: collapse;
    width: 100%;
}

.table-spec {
    width: 100%;
    max-width: 100%;
    empty-cells: show;
    border: 0;
}

td, th {
    border: 1px solid #dddddd;
    text-align: left;
    font-weight: normal;
}

td {
    padding: 6px 10px;
}

th {
    border-top: none;
    position: sticky;
    top: 0;
    padding: 10px;
    background: #212529;
    color: #ffffff;
    font-size: 14px;
    z-index: 1;
    background-clip: padding-box;
}

tbody tr:nth-child(even) {
    background-color: #f2f2f2;
}

td .txtarea {
    width: 100% !important;
}

td textarea:hover {
    border: 1px solid gray !important;
}
/*# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIm1vcmUtaW5mb3JtYXRpb24uY29tcG9uZW50LmNzcyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQTtJQUNJLHFDQUFxQztJQUNyQyxjQUFjO0FBQ2xCOztBQUVBO0lBQ0ksY0FBYztJQUNkLHlCQUF5QjtJQUN6QixXQUFXO0FBQ2Y7O0FBRUE7SUFDSSxXQUFXO0lBQ1gsZUFBZTtJQUNmLGlCQUFpQjtJQUNqQixTQUFTO0FBQ2I7O0FBRUE7SUFDSSx5QkFBeUI7SUFDekIsZ0JBQWdCO0lBQ2hCLG1CQUFtQjtBQUN2Qjs7QUFFQTtJQUNJLGlCQUFpQjtBQUNyQjs7QUFFQTtJQUNJLGdCQUFnQjtJQUNoQixnQkFBZ0I7SUFDaEIsTUFBTTtJQUNOLGFBQWE7SUFDYixtQkFBbUI7SUFDbkIsY0FBYztJQUNkLGVBQWU7SUFDZixVQUFVO0lBQ1YsNEJBQTRCO0FBQ2hDOztBQUVBO0lBQ0kseUJBQXlCO0FBQzdCOztBQUVBO0lBQ0ksc0JBQXNCO0FBQzFCOztBQUVBO0lBQ0ksaUNBQWlDO0FBQ3JDIiwiZmlsZSI6Im1vcmUtaW5mb3JtYXRpb24uY29tcG9uZW50LmNzcyIsInNvdXJjZXNDb250ZW50IjpbIi50YWJsZS1jb250YWluZXIge1xyXG4gICAgLyogbWF4LWhlaWdodDogY2FsYygxMDB2aCAtIDM2NXB4KTsgKi9cclxuICAgIG92ZXJmbG93OiBhdXRvO1xyXG59XHJcblxyXG50YWJsZSB7XHJcbiAgICBvdmVyZmxvdzogYXV0bztcclxuICAgIGJvcmRlci1jb2xsYXBzZTogY29sbGFwc2U7XHJcbiAgICB3aWR0aDogMTAwJTtcclxufVxyXG5cclxuLnRhYmxlLXNwZWMge1xyXG4gICAgd2lkdGg6IDEwMCU7XHJcbiAgICBtYXgtd2lkdGg6IDEwMCU7XHJcbiAgICBlbXB0eS1jZWxsczogc2hvdztcclxuICAgIGJvcmRlcjogMDtcclxufVxyXG5cclxudGQsIHRoIHtcclxuICAgIGJvcmRlcjogMXB4IHNvbGlkICNkZGRkZGQ7XHJcbiAgICB0ZXh0LWFsaWduOiBsZWZ0O1xyXG4gICAgZm9udC13ZWlnaHQ6IG5vcm1hbDtcclxufVxyXG5cclxudGQge1xyXG4gICAgcGFkZGluZzogNnB4IDEwcHg7XHJcbn1cclxuXHJcbnRoIHtcclxuICAgIGJvcmRlci10b3A6IG5vbmU7XHJcbiAgICBwb3NpdGlvbjogc3RpY2t5O1xyXG4gICAgdG9wOiAwO1xyXG4gICAgcGFkZGluZzogMTBweDtcclxuICAgIGJhY2tncm91bmQ6ICMyMTI1Mjk7XHJcbiAgICBjb2xvcjogI2ZmZmZmZjtcclxuICAgIGZvbnQtc2l6ZTogMTRweDtcclxuICAgIHotaW5kZXg6IDE7XHJcbiAgICBiYWNrZ3JvdW5kLWNsaXA6IHBhZGRpbmctYm94O1xyXG59XHJcblxyXG50Ym9keSB0cjpudGgtY2hpbGQoZXZlbikge1xyXG4gICAgYmFja2dyb3VuZC1jb2xvcjogI2YyZjJmMjtcclxufVxyXG5cclxudGQgLnR4dGFyZWEge1xyXG4gICAgd2lkdGg6IDEwMCUgIWltcG9ydGFudDtcclxufVxyXG5cclxudGQgdGV4dGFyZWE6aG92ZXIge1xyXG4gICAgYm9yZGVyOiAxcHggc29saWQgZ3JheSAhaW1wb3J0YW50O1xyXG59Il19 */`, "",{"version":3,"sources":["webpack://./src/app/View/core/manage-fleet/more-information/more-information.component.css"],"names":[],"mappings":"AAAA;IACI,qCAAqC;IACrC,cAAc;AAClB;;AAEA;IACI,cAAc;IACd,yBAAyB;IACzB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,eAAe;IACf,iBAAiB;IACjB,SAAS;AACb;;AAEA;IACI,yBAAyB;IACzB,gBAAgB;IAChB,mBAAmB;AACvB;;AAEA;IACI,iBAAiB;AACrB;;AAEA;IACI,gBAAgB;IAChB,gBAAgB;IAChB,MAAM;IACN,aAAa;IACb,mBAAmB;IACnB,cAAc;IACd,eAAe;IACf,UAAU;IACV,4BAA4B;AAChC;;AAEA;IACI,yBAAyB;AAC7B;;AAEA;IACI,sBAAsB;AAC1B;;AAEA;IACI,iCAAiC;AACrC;AACA,o6DAAo6D","sourcesContent":[".table-container {\r\n    /* max-height: calc(100vh - 365px); */\r\n    overflow: auto;\r\n}\r\n\r\ntable {\r\n    overflow: auto;\r\n    border-collapse: collapse;\r\n    width: 100%;\r\n}\r\n\r\n.table-spec {\r\n    width: 100%;\r\n    max-width: 100%;\r\n    empty-cells: show;\r\n    border: 0;\r\n}\r\n\r\ntd, th {\r\n    border: 1px solid #dddddd;\r\n    text-align: left;\r\n    font-weight: normal;\r\n}\r\n\r\ntd {\r\n    padding: 6px 10px;\r\n}\r\n\r\nth {\r\n    border-top: none;\r\n    position: sticky;\r\n    top: 0;\r\n    padding: 10px;\r\n    background: #212529;\r\n    color: #ffffff;\r\n    font-size: 14px;\r\n    z-index: 1;\r\n    background-clip: padding-box;\r\n}\r\n\r\ntbody tr:nth-child(even) {\r\n    background-color: #f2f2f2;\r\n}\r\n\r\ntd .txtarea {\r\n    width: 100% !important;\r\n}\r\n\r\ntd textarea:hover {\r\n    border: 1px solid gray !important;\r\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
